import { useEffect } from "react";

// Lets any page with its own sticky bottom action bar tell Kiri's floating
// launcher to sit clear of it (see .kiri-launcher-pos in index.css). Pass the
// bar's height in px; clearance = height + 16px gap. Resets on unmount.
export function useKiriClearance(heightPx, active = true) {
  useEffect(() => {
    if (!active || !heightPx) return;
    const root = document.documentElement;
    const prev = root.style.getPropertyValue("--kiri-clear");
    root.style.setProperty("--kiri-clear", `${heightPx + 16}px`);
    return () => { root.style.setProperty("--kiri-clear", prev || ""); };
  }, [heightPx, active]);
}
